import { useNavigate } from 'react-router-dom';
import { Building2 } from 'lucide-react';

/**
 * Reusable clickable branch name. Navigates to the single-branch summary page.
 *
 * Usage:
 *   <BranchLink branchId={b.id} name={b.name} />
 */
export default function BranchLink({ branchId, name, showIcon = false, className = '' }) {
  const navigate = useNavigate();
  if (!name) return null;
  if (!branchId) return <span className={className}>{name}</span>;
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        navigate(`/branch-summary?branch_id=${encodeURIComponent(branchId)}`);
      }}
      className={`inline-flex items-center gap-1 text-primary hover:underline hover:text-primary/80 font-medium transition-colors ${className}`}
      data-testid={`branch-link-${branchId}`}
      title={`View details of ${name}`}
    >
      {showIcon && <Building2 size={12} className="opacity-70" />}
      <span>{name}</span>
    </button>
  );
}
